import type { Email, EmailWorkflowStatus } from '../useData';

export const WORKFLOW_STATUS_LABELS: Record<EmailWorkflowStatus, string> = {
  open: 'Open',
  working: 'In Progress',
  closed: 'Closed',
};

export const WORKFLOW_STATUS_CHIP: Record<
  EmailWorkflowStatus,
  { dotClass: string; chipClass: string }
> = {
  open: {
    dotClass: 'bg-emerald-500',
    chipClass:
      'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-200 dark:border-emerald-800',
  },
  working: {
    dotClass: 'bg-amber-500',
    chipClass:
      'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800',
  },
  closed: {
    dotClass: 'bg-slate-400 dark:bg-slate-500',
    chipClass:
      'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:border-slate-600',
  },
};

export function assigneeDisplayName(email: Pick<Email, 'assignedToUser' | 'assignedToUserId'>): string | null {
  if (email.assignedToUserId == null) return null;
  const name = email.assignedToUser?.name?.trim();
  if (name) return name;
  const emailAddr = email.assignedToUser?.email?.trim();
  if (emailAddr) return emailAddr.split('@')[0] || emailAddr;
  return `User #${email.assignedToUserId}`;
}

export function assigneeInitial(name: string): string {
  const trimmed = name.trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?';
}

export function resolvedWorkflowStatus(
  email: Pick<Email, 'assignedToUserId' | 'workflowStatus'>,
): EmailWorkflowStatus | null {
  if (email.assignedToUserId == null) return null;
  return email.workflowStatus ?? 'open';
}
